import { render, staticRenderFns } from "./SeatsModal.vue?vue&type=template&id=199663a8&scoped=true"
import script from "./SeatsModal.vue?vue&type=script&lang=js"
export * from "./SeatsModal.vue?vue&type=script&lang=js"
import style0 from "./SeatsModal.vue?vue&type=style&index=0&id=199663a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199663a8",
  null
  
)

export default component.exports